import React from 'react';
import { SEO } from '../components/SEO';
export const TermsPage = () => {
  return <main data-id="element-1690">
      <SEO title="Algemene Voorwaarden | BKCustoms" description="Lees onze algemene voorwaarden. Informatie over garantie, betalingen en andere belangrijke voorwaarden bij BKCustoms auto styling diensten." data-id="element-1691" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-20" data-id="element-1692">
        <div className="absolute inset-0 overflow-hidden" data-id="element-1693">
          <div className="absolute inset-0 bg-black/90 z-10" data-id="element-1694"></div>
          <img src="https://images.unsplash.com/photo-1557597774-9d273605dfa9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Algemene Voorwaarden" className="w-full h-full object-cover object-center" data-id="element-1695" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-1696">
          <h1 className="text-4xl font-bold text-white mb-6" data-id="element-1697">
            Algemene Voorwaarden
          </h1>
        </div>
      </div>
      {/* Content Section */}
      <section className="bg-[#0a0a0a] py-16" data-id="element-1698">
        <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-1699">
          <div className="bg-[#0f0f0f] border border-[#222] rounded-lg p-8 md:p-10" data-id="element-1700">
            <div className="prose prose-invert max-w-none" data-id="element-1701">
              <p className="text-white/80 mb-6" data-id="element-1702">
                <strong data-id="element-1703">Laatst bijgewerkt: 1 juni 2023</strong>
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1704">
                1. Algemeen
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1705">
                Deze algemene voorwaarden zijn van toepassing op alle
                aanbiedingen, werkzaamheden, offertes en overeenkomsten tussen
                BKCustoms, hierna te noemen "Opdrachtnemer", en een
                Opdrachtgever waarop Opdrachtnemer deze voorwaarden van
                toepassing heeft verklaard.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1706">
                2. Offertes en aanbiedingen
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1707">
                Alle offertes en aanbiedingen van Opdrachtnemer zijn
                vrijblijvend en hebben een geldigheidsduur van 30 dagen, tenzij
                anders aangegeven. Een offerte of aanbieding vervalt indien het
                product waarop de offerte of de aanbieding betrekking heeft in
                de tussentijd niet meer beschikbaar is.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1708">
                3. Uitvoering van de overeenkomst
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1709">
                Opdrachtnemer zal de overeenkomst naar beste inzicht en vermogen
                en overeenkomstig de eisen van goed vakmanschap uitvoeren. Alle
                werkzaamheden worden uitgevoerd op basis van een
                inspanningsverbintenis.
              </p>
              <p className="text-white/80 mb-4" data-id="element-1710">
                Opdrachtgever draagt er zorg voor dat alle gegevens, waarvan
                Opdrachtnemer aangeeft dat deze noodzakelijk zijn voor het
                uitvoeren van de overeenkomst, tijdig aan Opdrachtnemer worden
                verstrekt.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1711">
                4. Betaling en incassokosten
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1712">
                Betaling dient steeds te geschieden binnen 14 dagen na
                factuurdatum, tenzij schriftelijk anders overeengekomen. Voor
                bepaalde diensten kan een aanbetaling worden gevraagd.
              </p>
              <p className="text-white/80 mb-4" data-id="element-1713">
                Indien de Opdrachtgever in gebreke blijft in de tijdige betaling
                van een factuur, dan is de Opdrachtgever van rechtswege in
                verzuim. De Opdrachtgever is dan de wettelijke rente
                verschuldigd.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1714">
                5. Garantie
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1715">
                Opdrachtnemer biedt garantie op de uitgevoerde werkzaamheden en
                gebruikte materialen conform de garantievoorwaarden die bij de
                offerte worden vermeld. De garantietermijn varieert per dienst:
              </p>
              <ul className="list-disc pl-6 text-white/80 mb-4" data-id="element-1716">
                <li data-id="element-1717">Carwraps: 3 jaar garantie op materiaal en installatie</li>
                <li data-id="element-1718">
                  Raamtinting: 5 jaar garantie tegen verkleuring en loslaten
                </li>
                <li data-id="element-1719">
                  Overige diensten: garantietermijn wordt per dienst
                  gespecificeerd
                </li>
              </ul>
              <p className="text-white/80 mb-4" data-id="element-1720">
                Garantie vervalt bij oneigenlijk gebruik, aanpassingen door
                derden, of schade veroorzaakt door externe factoren.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1721">
                6. Aansprakelijkheid
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1722">
                Opdrachtnemer is uitsluitend aansprakelijk voor directe schade
                die is ontstaan door bewuste roekeloosheid of opzet van
                Opdrachtnemer. Onder directe schade wordt uitsluitend verstaan
                de redelijke kosten ter vaststelling van de oorzaak en de omvang
                van de schade, de eventuele redelijke kosten gemaakt om de
                gebrekkige prestatie van Opdrachtnemer aan de overeenkomst te
                laten beantwoorden en redelijke kosten gemaakt ter voorkoming of
                beperking van schade.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1723">
                7. Vrijwaring
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1724">
                De Opdrachtgever vrijwaart Opdrachtnemer voor eventuele
                aanspraken van derden, die in verband met de uitvoering van de
                overeenkomst schade lijden en waarvan de oorzaak aan andere dan
                aan Opdrachtnemer toerekenbaar is.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1725">
                8. Intellectuele eigendom
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1726">
                Opdrachtnemer behoudt zich de rechten en bevoegdheden voor die
                hem toekomen op grond van de Auteurswet en andere intellectuele
                wet- en regelgeving.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1727">
                9. Toepasselijk recht en geschillen
              </h2>
              <p className="text-white/80 mb-4" data-id="element-1728">
                Op alle rechtsbetrekkingen waarbij Opdrachtnemer partij is, is
                uitsluitend het Nederlands recht van toepassing. De rechtbank in
                de vestigingsplaats van Opdrachtnemer is bij uitsluiting bevoegd
                van geschillen kennis te nemen.
              </p>
              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1729">
                10. Wijziging voorwaarden
              </h2>
              <p className="text-white/80" data-id="element-1730">
                Opdrachtnemer is bevoegd wijzigingen in deze voorwaarden aan te
                brengen. Deze wijzigingen treden in werking op het aangekondigde
                tijdstip van inwerkingtreding. Opdrachtnemer zal de gewijzigde
                voorwaarden tijdig aan de Opdrachtgever toezenden.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>;
};